import { BodyText, Callout } from "@/components/ui";
import { Link } from "@tanstack/react-router";
import { MissingPatientField } from "../network/useLabOrderEntryActions";

const missingPatientFieldsMap: Record<
  MissingPatientField,
  { display: string; medicalRecordsTab?: string }
> = {
  [MissingPatientField.FIRST_NAME]: { display: "First Name" },
  [MissingPatientField.LAST_NAME]: { display: "Last Name" },
  [MissingPatientField.DOB]: { display: "Date of Birth" },
  [MissingPatientField.GENDER]: { display: "Gender" },
  [MissingPatientField.PHONE_NUMBER]: {
    display: "Phone Number",
    medicalRecordsTab: "profile",
  },
};

export const MissingPatientDetails = ({
  missingPatientFields,
  patientId,
}: {
  missingPatientFields: MissingPatientField[];
  patientId: string;
}) => {
  return (
    <Callout title="Missing Patient Details" variant="warning">
      <div className="flex flex-col gap-2">
        <BodyText size="sm">
          This patient is missing the following information to electronically
          order labs.
          <ul className="list-outside list-disc pl-5 mt-2">
            {missingPatientFields?.map((detail) => (
              <li key={detail}>
                {missingPatientFieldsMap[detail].medicalRecordsTab ? (
                  <Link
                    // @ts-expect-error - medicalRecordsTab must be a route in the route tree
                    to={`/patient/$patientId/${missingPatientFieldsMap[detail].medicalRecordsTab}`}
                    params={{ patientId: patientId }}
                    search={(prevSearch) => ({
                      ...prevSearch,
                    })}
                  >
                    <BodyText
                      size="sm"
                      textColor="link"
                      bold
                      className="cursor-pointer"
                    >
                      {missingPatientFieldsMap[detail].display}
                    </BodyText>
                  </Link>
                ) : (
                  <BodyText size="sm">
                    {`${missingPatientFieldsMap[detail].display}: Contact support to update`}
                  </BodyText>
                )}
              </li>
            ))}
          </ul>
        </BodyText>
      </div>
    </Callout>
  );
};
